export const orderByLevelId = (levels) => {
  if (levels) {
    return levels.sort((a,b) => a.level - b.level)
  } else {
    return []
  }
} 

export const getLevelsSetting = (levels) => {
  return levels.map((level, index) => {
    return ({
      id: index,
      name: level.name,
      alias: level.alias,
      lengthSelect: level.lengthSelect ,
      showDefault: level.showDefault ,
      completed: false,
      configuration: level.steps.map((step, idx) => {
        return ({
          id: idx,
          name: step,
          configuration: {}
        })
      })
    })
  })
}
  